import { useMutation } from "react-query";
import { addInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useAddInvoice = () => {
  return useMutation(addInvoice);
};
